"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PatchLogForwarderRequest = exports.CreateLogForwarderRequest = exports.LogForwarder = exports.CollectionForwardingAction = exports.FunctionForwardingAction = exports.LogForwardingActionType = exports.BatchLogPolicy = exports.SingleLogPolicy = exports.LogPolicyType = exports.LogStatus = exports.LogType = void 0;
var json2typescript_1 = require("json2typescript");
var LogType;
(function (LogType) {
    LogType["AUTH"] = "auth";
    LogType["FUNCTION"] = "function";
    LogType["PUSH"] = "push";
    LogType["SERVICE"] = "service";
    LogType["TRIGGER"] = "trigger";
    LogType["GRAPHQL"] = "graphql";
    LogType["SYNC"] = "sync";
    LogType["SCHEMA"] = "schema";
    LogType["ENDPOINT"] = "endpoint";
})(LogType = exports.LogType || (exports.LogType = {}));
var LogStatus;
(function (LogStatus) {
    LogStatus["SUCCESS"] = "success";
    LogStatus["ERROR"] = "error";
})(LogStatus = exports.LogStatus || (exports.LogStatus = {}));
var LogPolicyType;
(function (LogPolicyType) {
    LogPolicyType["SINGLE"] = "single";
    LogPolicyType["BATCH"] = "batch";
})(LogPolicyType = exports.LogPolicyType || (exports.LogPolicyType = {}));
var LogPolicy = (function () {
    function LogPolicy(required) {
        this.type = LogPolicyType.SINGLE;
        Object.assign(this, required);
    }
    __decorate([
        (0, json2typescript_1.JsonProperty)('type', String),
        __metadata("design:type", String)
    ], LogPolicy.prototype, "type", void 0);
    LogPolicy = __decorate([
        (0, json2typescript_1.JsonObject)('LogPolicy'),
        __metadata("design:paramtypes", [Object])
    ], LogPolicy);
    return LogPolicy;
}());
var SingleLogPolicy = (function (_super) {
    __extends(SingleLogPolicy, _super);
    function SingleLogPolicy(required) {
        var _this = _super.call(this, __assign(__assign({}, required), { type: LogPolicyType.SINGLE })) || this;
        Object.assign(_this, required);
        return _this;
    }
    SingleLogPolicy = __decorate([
        (0, json2typescript_1.JsonObject)('SingleLogPolicy'),
        __metadata("design:paramtypes", [Object])
    ], SingleLogPolicy);
    return SingleLogPolicy;
}(LogPolicy));
exports.SingleLogPolicy = SingleLogPolicy;
var BatchLogPolicy = (function (_super) {
    __extends(BatchLogPolicy, _super);
    function BatchLogPolicy(required) {
        var _this = _super.call(this, __assign(__assign({}, required), { type: LogPolicyType.BATCH })) || this;
        Object.assign(_this, required);
        return _this;
    }
    BatchLogPolicy = __decorate([
        (0, json2typescript_1.JsonObject)('BatchLogPolicy'),
        __metadata("design:paramtypes", [Object])
    ], BatchLogPolicy);
    return BatchLogPolicy;
}(LogPolicy));
exports.BatchLogPolicy = BatchLogPolicy;
var LogForwardingActionType;
(function (LogForwardingActionType) {
    LogForwardingActionType["FUNCTION"] = "function";
    LogForwardingActionType["COLLECTION"] = "collection";
})(LogForwardingActionType = exports.LogForwardingActionType || (exports.LogForwardingActionType = {}));
var LogForwardingAction = (function () {
    function LogForwardingAction(required) {
        this.id = '';
        this.type = LogForwardingActionType.FUNCTION;
        Object.assign(this, required);
    }
    __decorate([
        (0, json2typescript_1.JsonProperty)('_id'),
        __metadata("design:type", Object)
    ], LogForwardingAction.prototype, "id", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('type', String),
        __metadata("design:type", String)
    ], LogForwardingAction.prototype, "type", void 0);
    LogForwardingAction = __decorate([
        (0, json2typescript_1.JsonObject)('LogForwardingAction'),
        __metadata("design:paramtypes", [Object])
    ], LogForwardingAction);
    return LogForwardingAction;
}());
var FunctionForwardingAction = (function (_super) {
    __extends(FunctionForwardingAction, _super);
    function FunctionForwardingAction(required) {
        var _this = _super.call(this, required) || this;
        Object.assign(_this, required);
        return _this;
    }
    FunctionForwardingAction = __decorate([
        (0, json2typescript_1.JsonObject)('FunctionForwardingAction'),
        __metadata("design:paramtypes", [Object])
    ], FunctionForwardingAction);
    return FunctionForwardingAction;
}(LogForwardingAction));
exports.FunctionForwardingAction = FunctionForwardingAction;
var CollectionForwardingAction = (function (_super) {
    __extends(CollectionForwardingAction, _super);
    function CollectionForwardingAction(required) {
        var _this = _super.call(this, required) || this;
        _this.database = '';
        _this.collection = '';
        Object.assign(_this, required);
        return _this;
    }
    __decorate([
        (0, json2typescript_1.JsonProperty)('database'),
        __metadata("design:type", Object)
    ], CollectionForwardingAction.prototype, "database", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('collection', String),
        __metadata("design:type", Object)
    ], CollectionForwardingAction.prototype, "collection", void 0);
    CollectionForwardingAction = __decorate([
        (0, json2typescript_1.JsonObject)('CollectionForwardingAction'),
        __metadata("design:paramtypes", [Object])
    ], CollectionForwardingAction);
    return CollectionForwardingAction;
}(LogForwardingAction));
exports.CollectionForwardingAction = CollectionForwardingAction;
var jsonConvert = new json2typescript_1.JsonConvert();
var ActionConverter = (function () {
    function ActionConverter() {
    }
    ActionConverter.prototype.serialize = function (action) {
        var _a;
        var type = (_a = action.type) !== null && _a !== void 0 ? _a : '';
        switch (type) {
            case LogForwardingActionType.FUNCTION:
                return jsonConvert.serializeObject(action, FunctionForwardingAction);
            case LogForwardingActionType.COLLECTION:
                return jsonConvert.serializeObject(action, CollectionForwardingAction);
            default:
                throw new Error('unexpected action type');
        }
    };
    ActionConverter.prototype.deserialize = function (data) {
        if ('type' in data) {
            var type = data.type;
            switch (type) {
                case LogForwardingActionType.FUNCTION:
                    return jsonConvert.deserializeObject(data, FunctionForwardingAction);
                case LogForwardingActionType.COLLECTION:
                    return jsonConvert.deserializeObject(data, CollectionForwardingAction);
                default:
                    throw new Error('unexpected action type');
            }
        }
        throw new Error('unexpected action type');
    };
    ActionConverter = __decorate([
        json2typescript_1.JsonConverter
    ], ActionConverter);
    return ActionConverter;
}());
var LogForwarder = (function () {
    function LogForwarder(required) {
        this.id = '';
        this.name = '';
        this.logTypes = [];
        this.logStatuses = [];
        this.policy = new LogPolicy();
        this.action = new LogForwardingAction();
        this.disabled = false;
        this.error = undefined;
        this.errorCoId = undefined;
        Object.assign(this, required);
    }
    __decorate([
        (0, json2typescript_1.JsonProperty)('_id'),
        __metadata("design:type", Object)
    ], LogForwarder.prototype, "id", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('name'),
        __metadata("design:type", Object)
    ], LogForwarder.prototype, "name", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('log_types', [String]),
        __metadata("design:type", Array)
    ], LogForwarder.prototype, "logTypes", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('log_statuses', [String]),
        __metadata("design:type", Array)
    ], LogForwarder.prototype, "logStatuses", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('policy'),
        __metadata("design:type", LogPolicy)
    ], LogForwarder.prototype, "policy", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('action', ActionConverter),
        __metadata("design:type", LogForwardingAction)
    ], LogForwarder.prototype, "action", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('disabled'),
        __metadata("design:type", Object)
    ], LogForwarder.prototype, "disabled", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('error', String, true),
        __metadata("design:type", String)
    ], LogForwarder.prototype, "error", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('error_co_id', String, true),
        __metadata("design:type", String)
    ], LogForwarder.prototype, "errorCoId", void 0);
    LogForwarder = __decorate([
        (0, json2typescript_1.JsonObject)('LogForwarder'),
        __metadata("design:paramtypes", [Object])
    ], LogForwarder);
    return LogForwarder;
}());
exports.LogForwarder = LogForwarder;
var CreateLogForwarderRequest = (function () {
    function CreateLogForwarderRequest(required) {
        this.name = '';
        this.logTypes = [];
        this.logStatuses = [];
        this.policy = new LogPolicy();
        this.action = new LogForwardingAction();
        this.disabled = false;
        Object.assign(this, required);
    }
    __decorate([
        (0, json2typescript_1.JsonProperty)('name'),
        __metadata("design:type", Object)
    ], CreateLogForwarderRequest.prototype, "name", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('log_types', [String]),
        __metadata("design:type", Array)
    ], CreateLogForwarderRequest.prototype, "logTypes", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('log_statuses', [String]),
        __metadata("design:type", Array)
    ], CreateLogForwarderRequest.prototype, "logStatuses", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('policy'),
        __metadata("design:type", LogPolicy)
    ], CreateLogForwarderRequest.prototype, "policy", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('action', ActionConverter),
        __metadata("design:type", LogForwardingAction)
    ], CreateLogForwarderRequest.prototype, "action", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('disabled'),
        __metadata("design:type", Object)
    ], CreateLogForwarderRequest.prototype, "disabled", void 0);
    CreateLogForwarderRequest = __decorate([
        (0, json2typescript_1.JsonObject)('CreateLogForwarderRequest'),
        __metadata("design:paramtypes", [Object])
    ], CreateLogForwarderRequest);
    return CreateLogForwarderRequest;
}());
exports.CreateLogForwarderRequest = CreateLogForwarderRequest;
var PatchLogForwarderRequest = (function () {
    function PatchLogForwarderRequest(partial) {
        this.name = undefined;
        this.logTypes = undefined;
        this.logStatuses = undefined;
        this.policy = undefined;
        this.action = undefined;
        this.disabled = undefined;
        Object.assign(this, partial);
    }
    __decorate([
        (0, json2typescript_1.JsonProperty)('name', String, true),
        __metadata("design:type", String)
    ], PatchLogForwarderRequest.prototype, "name", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('log_types', [String], true),
        __metadata("design:type", Array)
    ], PatchLogForwarderRequest.prototype, "logTypes", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('log_statuses', [String], true),
        __metadata("design:type", Array)
    ], PatchLogForwarderRequest.prototype, "logStatuses", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('policy', LogPolicy, true),
        __metadata("design:type", LogPolicy)
    ], PatchLogForwarderRequest.prototype, "policy", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('action', ActionConverter, true),
        __metadata("design:type", LogForwardingAction)
    ], PatchLogForwarderRequest.prototype, "action", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('disabled', Boolean, true),
        __metadata("design:type", Boolean)
    ], PatchLogForwarderRequest.prototype, "disabled", void 0);
    PatchLogForwarderRequest = __decorate([
        (0, json2typescript_1.JsonObject)('PatchLogForwarderRequest'),
        __metadata("design:paramtypes", [Object])
    ], PatchLogForwarderRequest);
    return PatchLogForwarderRequest;
}());
exports.PatchLogForwarderRequest = PatchLogForwarderRequest;
//# sourceMappingURL=LogForwarder.js.map